import { Api } from '../../../utility/client';

export async function startDemoSession() {
  return Api.post('/v1/vbase/demo/start');
}
